import { createSelector } from 'reselect';
import moment from 'moment';

import getCurrentOrder from './getCurrentOrder';

export default createSelector([getCurrentOrder], currentOrder => {
  const { bufferPickupTime } = currentOrder;

  return bufferPickupTime ? moment(bufferPickupTime).format() : null;
});
